import { useState } from "react";
import "../Styles/join.css";
import JoinModal from "../components/JoinModel";

function Join() {
   const [isJoinOpen, setIsJoinOpen] = useState(false);
   const [memberId, setMemberId] = useState("");
  return (
    <>
      <section className="join-hero">
        {/* Single full-screen background image (no slideshow) */}
        <div className="join-hero-bg">
          <img
            src="/assets/join.png"
            alt="Vanakkam HRD community"
            className="join-hero-bg-img"
          />
        </div>

        {/* Dark left-to-right shade for text readability */}
        <div className="join-hero-overlay"></div>

        {/* Actual content, sits above the background */}
        <div className="join-hero-content">
        <div className="join-hero-left">
            <h1 className="join-hero-title">
            Join Vanakkam HRD – Where India's HR Community Connects, Learns, and Inspires.
            </h1>

            <button
  type="button"
  className="join-hero-btn"
  onClick={() => setIsJoinOpen(true)}
>
  Become a Member
  <img
    src="/assets/About_arrow_icon.png"
    alt="Arrow Icon"
    className="join-arrow-icon"
  />
</button>
        </div>
        </div>
      </section>

      {/* ===================================================
          VERIFY MEMBERSHIP ID SECTION
      =================================================== */}
      <section className="verify-section">
        <div className="verify-container">
          <div className="verify-left">
            <h2 className="verify-title">
              Verify a Vanakkam HRD Community Membership ID
            </h2>
            <p className="verify-desc">
              Verify the authenticity of a Vanakkam HRD community membership or
              issued certificate using a unique identification number. Give
              members a trusted credential they can share and employers a simple
              way to validate its authenticity.
            </p>
          </div>

          <div className="verify-card">
            <h3 className="verify-card-title">Verify Membership ID</h3>
            <p className="verify-card-sub">
              Enter the Membership ID to check its verification status.
            </p>

            <label htmlFor="verify-member-id" className="verify-label">
              Membership ID
            </label>
            <input
              id="verify-member-id"
              type="text"
              className="verify-input"
              placeholder="e.g. VH-2024-XXXXX"
              value={memberId}
              onChange={(e) => setMemberId(e.target.value)}
            />

            <button type="button" className="verify-btn">
              Verify to Member ID
            </button>

            <p className="verify-help">
              Need help finding your ID?{" "}
              <a href="/contact" className="verify-help-link">
                Contact Support
              </a>
            </p>
          </div>
        </div>
      </section>

      {/* ===================================================
          VERIFY FEATURES (4 CARDS) SECTION
      =================================================== */}
      <section className="verifyfeat-section">
        <div className="verifyfeat-container">
          <div className="verifyfeat-card">
            <div className="verifyfeat-icon">
              <img
                src="/assets/jc_icn_01.png"
                alt="Unique Membership and Certificate ID"
                className="verifyfeat-icon-img"
              />
            </div>
            <h3 className="verifyfeat-title">Unique Membership &amp; Certificate ID</h3>
            <p className="verifyfeat-desc">
              Every registered member and issued certificate can be assigned a
              unique reference ID for reliable identification.
            </p>
          </div>

          <div className="verifyfeat-card">
            <div className="verifyfeat-icon">
              <img
                src="/assets/jc_icn_02.png"
                alt="QR-Enabled Verification"
                className="verifyfeat-icon-img"
              />
            </div>
            <h3 className="verifyfeat-title">QR-Enabled Verification</h3>
            <p className="verifyfeat-desc">
              Scan the QR code on a digital membership card or certificate to
              access its verification page.
            </p>
          </div>

          <div className="verifyfeat-card">
            <div className="verifyfeat-icon">
              <img
                src="/assets/jc_icn_03.png"
                alt="Privacy-Conscious Records"
                className="verifyfeat-icon-img"
              />
            </div>
            <h3 className="verifyfeat-title">Privacy-Conscious Records</h3>
            <p className="verifyfeat-desc">
              Only approved verification information is displayed publicly,
              helping protect members' personal information.
            </p>
          </div>

          <div className="verifyfeat-card">
            <div className="verifyfeat-icon">
              <img
                src="/assets/jc_icn_04.png"
                alt="Trusted Verification Register"
                className="verifyfeat-icon-img"
              />
            </div>
            <h3 className="verifyfeat-title">Trusted Verification Register</h3>
            <p className="verifyfeat-desc">
              The production system will connect to an approved Vanakkam HRD
              membership and certificate register to verify records.
            </p>
          </div>
        </div>
      </section>

      {/* ===================================================
          WHY JOIN THE VANAKKAM HRD COMMUNITY SECTION
      =================================================== */}
      <section className="whyjoin-section">
        <div className="whyjoin-container">
          <h2 className="whyjoin-heading">Why Join the Vanakkam HRD Community?</h2>
          <div className="whyjoin-underline"></div>

          {/* Row 1 - 2 boxes */}
                        <div className="whyjoin-row whyjoin-row-top">
                            <div className="whyjoin-card">
                        <div className="whyjoin-icon whyjoin-icon-blue">
                <img
                    src="/assets/join_icon_1.png"
                    alt="Join Icon 1"
                    className="whyjoin-icon-img"
                />
                </div>
              <h3 className="whyjoin-card-title">Networking Opportunities</h3>
              <p className="whyjoin-card-desc">
                Connect with HR professionals, business leaders, and industry experts. Build meaningful relationships that open doors to new opportunities, collaborations, and career growth.
              </p>
            </div>

            <div className="whyjoin-card">
              <div className="whyjoin-icon whyjoin-icon-blue">
  <img
    src="/assets/join_icon_2.png"
    alt="Join Icon 2"
    className="whyjoin-icon-img"
  />
</div>
              <h3 className="whyjoin-card-title">Fun, Friendship &amp; Community</h3>
              <p className="whyjoin-card-desc">
                Learning is more meaningful when shared. Build lasting friendships, celebrate successes, and become part of a vibrant HR community that supports your professional journey.
              </p>
            </div>
          </div>

          {/* Row 2 - 3 boxes */}
          <div className="whyjoin-row whyjoin-row-bottom">
            <div className="whyjoin-card">
              <div className="whyjoin-icon whyjoin-icon-blue">
  <img
    src="/assets/join_icon_3.png"
    alt="Join Icon 2"
    className="whyjoin-icon-img"
  />
</div>
              <h3 className="whyjoin-card-title">Answers to Your Questions</h3>
              <p className="whyjoin-card-desc">
                Get practical guidance and expert advice on today's HR challenges, trends, and best practices from experienced professionals.
              </p>
            </div>

            <div className="whyjoin-card">
              <div className="whyjoin-icon whyjoin-icon-blue">
  <img
    src="/assets/join_icon_4.png"
    alt="Join Icon 3"
    className="whyjoin-icon-img"
  />
</div>
              <h3 className="whyjoin-card-title">Discussions &amp; Insights</h3>
              <p className="whyjoin-card-desc">
                Engage in thought-provoking conversations, exchange ideas, and gain valuable insights on the future of HR, leadership, and workplace transformation.
              </p>
            </div>

            <div className="whyjoin-card">
              <div className="whyjoin-icon whyjoin-icon-blue">
  <img
    src="/assets/join_icon_5.png"
    alt="Join Icon 5"
    className="whyjoin-icon-img"
  />
</div>
              <h3 className="whyjoin-card-title">Solutions to Your Challenges</h3>
              <p className="whyjoin-card-desc">
                Discover innovative solutions, real-world case studies, and proven strategies to overcome workplace and people management challenges.
              </p>
            </div>
          </div>
        </div>
        
      </section>
      <JoinModal
        isOpen={isJoinOpen}
        onClose={() => setIsJoinOpen(false)}
      />
    </>
  );
}

export default Join;